module.exports = __webpack_public_path__ + "assets/img/goods-demo.86bbfae6.png";